'use strict';

import { element } from './dom.js';

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

import { isFunction as _isFunction, isPlainObject, each as _each, map as _map, extend, Event as _Event, bind as _bind } from 'jquery';

export const isArray = Array.isArray;
export const isFunction = _isFunction;
export const isObject = isPlainObject;
export const bind = _bind;
export function each(collection, cb) {
  // stupid argument order for jQuery.each
  _each(collection, reverseArgs);
  function reverseArgs(index, value) {
    return cb(value, index);
  }
}
export const map = _map;
export const mixin = extend;
export const Event = _Event;
export function isMsie(agentString) {
  if (agentString === undefined) { agentString = navigator.userAgent; }
  // from https://github.com/ded/bowser/blob/master/bowser.js
  if ((/(msie|trident)/i).test(agentString)) {
    var match = agentString.match(/(msie |rv:)(\d+(.\d+)?)/i);
    if (match) { return match[2]; }
  }
  return false;
}
export function escapeRegExChars(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
export function isNumber(obj) { return typeof obj === 'number'; }
export function toStr(s) {
  return s === undefined || s === null ? '' : s + '';
}
export function cloneDeep(obj) {
  var clone = mixin({}, obj);
  each(clone, function (value, key) {
    if (value) {
      if (isArray(value)) {
        clone[key] = [].concat(value);
      } else if (isObject(value)) {
        clone[key] = cloneDeep(value);
      }
    }
  });
  return clone;
}
export function error(msg) {
  throw new Error(msg);
}
export function every(obj, test) {
  var result = true;
  if (!obj) {
    return result;
  }
  each(obj, function (val, key) {
    if (result) {
      result = test.call(null, val, key, obj) && result;
    }
  });
  return !!result;
}
export function any(obj, test) {
  var found = false;
  if (!obj) {
    return found;
  }
  each(obj, function (val, key) {
    if (test.call(null, val, key, obj)) {
      found = true;
      return false;
    }
  });
  return found;
}
export const getUniqueId = (function () {
  var counter = 0;
  return function () { return counter++; };
})();
export function templatify(obj) {
  if (isFunction(obj)) {
    return obj;
  }
  var $template = element(obj);
  if ($template.prop('tagName') === 'SCRIPT') {
    return function template() { return $template.text(); };
  }
  return function template() { return String(obj); };
}
export function defer(fn) { setTimeout(fn, 0); }
export function noop() { }
export function formatPrefix(prefix, noPrefix) {
  return noPrefix ? '' : prefix + '-';
}
export function className(prefix, clazz, skipDot) {
  return (skipDot ? '' : '.') + prefix + clazz;
}
export function escapeHighlightedString(str, highlightPreTag, highlightPostTag) {
  highlightPreTag = highlightPreTag || '<em>';
  var pre = document.createElement('div');
  pre.appendChild(document.createTextNode(highlightPreTag));

  highlightPostTag = highlightPostTag || '</em>';
  var post = document.createElement('div');
  post.appendChild(document.createTextNode(highlightPostTag));

  var div = document.createElement('div');
  div.appendChild(document.createTextNode(str));
  return div.innerHTML
    .replace(RegExp(escapeRegExp(pre.innerHTML), 'g'), highlightPreTag)
    .replace(RegExp(escapeRegExp(post.innerHTML), 'g'), highlightPostTag);
}
